export const rssFeeds = [
  {
    name: 'Linux Kernel',
    url: 'https://www.kernel.org/feeds/kdist.xml',
    category: 'linux',
    defaultImages: [
      'https://images.unsplash.com/photo-1629654297299-c8506221ca97',
      'https://images.unsplash.com/photo-1557853197-aefb550b6fdc'
    ]
  },
  {
    name: 'OMG Ubuntu',
    url: 'https://feeds.feedburner.com/d0od',
    category: 'linux',
    defaultImages: [
      'https://images.unsplash.com/photo-1618477247222-acbdb0e159b3',
      'https://images.unsplash.com/photo-1607799279861-4dd421887fb3'
    ]
  },
  {
    name: 'Quantum Computing Report',
    url: 'https://quantumcomputingreport.com/feed/',
    category: 'quantum',
    defaultImages: [
      'https://images.unsplash.com/photo-1635070041078-e363dbe005cb',
      'https://images.unsplash.com/photo-1628595351029-c2bf17511435'
    ]
  }
];
